const organizationsQueryKeys = {
  list: () => ["organizations", "list"],
  infiniteList: () => ["organizations", "infinite-list"],
};

export const OrganizationsQuery = {
  queryKeys: organizationsQueryKeys,
};
